var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('em',{staticClass:"lt_text"},[_vm._v("State")]),_vm._v(" "),_c('span',{staticClass:"int_type_no_border mgr_5"},[_c('CodeSelect',{attrs:{"width":100,"codeWidth":120,"showDesc":false,"codes":_vm.filteredStates},on:{"input":_vm.updateValue},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }